<template>
  <a class="option card-box" @click="clickHandler">
    <div class="icon">
      <font-awesome-icon :icon="icon" size="5x"/>
    </div>
    <div class="text">
      <h4>{{label}}</h4>
      <p v-if="description">{{description}}</p>
    </div>
  </a>
</template>

<script>
export default {
  name: 'Option',
  props: {
    icon: [String, Array],
    value: String,
    label: String,
    description: {
      type: String,
      required: false
    }
  },
  methods: {
    clickHandler() {
      const { $parent } = this

      $parent.selectValueHandler
        && $parent.selectValueHandler(this.value)
    }
  }
}
</script>
